import React from 'react'
import { StyleSheet, Text } from 'react-native'

import { Stack } from '@zet/design-system/layout'
import { useUserContext } from '@zet/feature-user'
import TrainingCertificate from '@zet/svg/trainingCertificate'
import { DEVICE_WIDTH } from '@zet/utils/Constants'
import { CertificateImageProps } from '@zet/utils/interface'

const CerificateImage = React.forwardRef(
  ({ description1, description2, ...props }: CertificateImageProps, ref) => {
    const { data } = useUserContext()

    return (
      <Stack
        ref={ref}
        onLayout={(event) => {
          const { width } = event.nativeEvent.layout
        }}
        collapsable={false}
      >
        <TrainingCertificate width={DEVICE_WIDTH} {...props} />
        <Stack style={styles.container}>
          <Text style={styles.fullname}>{data?.fullName}</Text>
          <Text style={styles.description1}>
            {description1}{' '}
            <Text style={styles.description2}>{description2}</Text>
          </Text>
        </Stack>
      </Stack>
    )
  }
)

const styles = StyleSheet.create({
  container: {
    top: '53%',
    position: 'absolute',
    width: DEVICE_WIDTH,
    alignItems: 'center',
  },
  fullname: {
    color: '#022359',
    fontWeight: '700',
    fontSize: 12,
  },
  description1: {
    marginTop: 30,
    color: '#022359',
    fontSize: 9,
    width: '85%',
    lineHeight: 16,
    textAlign: 'center',
  },
  description2: { fontWeight: '700' },
})

export { CerificateImage }
